import useMountEffect from '@restart/hooks/useMountEffect';
import { RiCompassLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import CompassModal from '@/components/modals/calibration/Compass';
import { modalManager } from '@/libs/ModalContainer';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modalManager.show(CompassModal, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Compass';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiCompassLine;
Command.Panel = Panel;

export default Command;
